import React from "react";
import Modal from "../../../components/modal";

const ShowStagesModal = ({ show, onClose, heading, initialData = {} }) => {
    const stage = initialData?.status;



    const getisPurchased = (tenderData) => {
        const purchaseData = tenderData.finalProduct?.finalRawProducts
            .map((data) => ({
                tender_id: tenderData.id,
                rawProductId: data.raw_product_id,
                quantity: calculateRequired(data?.quantity, calculateQuantity(data.rawProducts?.RawProductVendors)),
            }))
            .filter((product) => product.quantity > 0);

        if (purchaseData.length === 0) {
            return false;
        }
        return true;
    }


    const calculateQuantity = (vendors) => {
        let finalQuantity = 0;
        vendors?.forEach((e) => {
            finalQuantity += e.quantity;
        });

        return finalQuantity;
    };

    const calculateRequired = (total, current) => {
        const requiredQuantity = total - current;
        if (requiredQuantity < 0) {
            return 0;
        }
        return requiredQuantity;
    };

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <ul style={{ listStyle: "none"}}>
                <li><h5>{stage == 0 && ("✅")} Sale request</h5> </li>
                <li><h5>{stage == 1 && ("✅")} Cost Estimation </h5></li>
                <li><h5>{stage == 2 && ("✅")} Order</h5> </li> 
                <li><h5>{(stage == 2 || stage == 3) && getisPurchased(initialData) && ("✅")} In Purchase</h5> </li>
                <li><h5>{stage == 4 && ("✅")} In Production </h5></li>
                <li><h5>{stage == 5 && ("✅")} Ready to Deliver</h5> </li> 
                <li><h5>{stage == 6 && ("✅")} Delivered</h5> </li>
            </ul>
        </Modal>
    );
};

export default ShowStagesModal;
